import { Component, inject, OnInit } from '@angular/core';
import { SubAccountDetails } from '../sms-call';
import { SmsCallService } from '../sms-call.service';
import { SettingsCommunicationsActiveComponent } from '../settings-communications-active/settings-communications-active.component';
import { faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SmsCallTermsModalComponent } from '../modals/sms-call-terms-modal/sms-call-terms-modal.component';
import { ConfirmationModalComponent } from '@main/confirmation-modal/confirmation-modal.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SettingsCommunicationsRegistrationComponent } from '../settings-communications-registration/settings-communications-registration.component';

@Component({
  selector: 'app-settings-communications',
  imports: [SettingsCommunicationsRegistrationComponent, SettingsCommunicationsActiveComponent, FaIconComponent],
  templateUrl: './settings-communications.component.html',
  styleUrl: './settings-communications.component.css'
})
export class SettingsCommunicationsComponent implements OnInit {

  // Properties
  subAccountDetails: SubAccountDetails;
  isCommunicationsActive: boolean = false;

  // Font Awesome Properties
  faToggleOff = faToggleOff;
  faToggleOn = faToggleOn;

  // Injections
  private smsCallService = inject(SmsCallService);
  private modalService = inject(NgbModal);

  ngOnInit(): void {
    // this.getTwilioSubaccountSettings();
  }

  // Get Twilio Subaccount Settings
  private getTwilioSubaccountSettings(): void {
    this.smsCallService.getTwilioSubaccountSettings().subscribe((subAccountDetails) => {
      this.subAccountDetails = subAccountDetails;
      this.isCommunicationsActive = subAccountDetails?.status != 'INACTIVE';
    });
  }

  // Toggle Enable SMS
  toggleEnableSms() {
    if (this.isCommunicationsActive) {
      this.openDisableSmsConfirmationModal();
    } else {
      if (this.subAccountDetails) {
        this.smsCallService.toggleTwilioStatus(true);
      } else {
        const modalRef = this.modalService.open(SmsCallTermsModalComponent);
        modalRef.componentInstance.agreed.subscribe(() => {
          this.smsCallService.toggleTwilioStatus(true);
          this.getTwilioSubaccountSettings();
        });
      }
    }
  }

  // Open Disable SMS Confirmation Modal
  private openDisableSmsConfirmationModal(): void {
    const confirmationModalRef = this.modalService.open(ConfirmationModalComponent);
    confirmationModalRef.componentInstance.title = 'Disable SMS/Calls?';
    confirmationModalRef.componentInstance.message = 'Disabling SMS/Calls will hide the functionality within Tinsel CRM, but you will still incur charges until all phone numbers are released.';
    confirmationModalRef.componentInstance.actionBtnTitle = 'Continue';
    confirmationModalRef.componentInstance.confirmed.subscribe(() => {
      this.smsCallService.toggleTwilioStatus(false);
      this.getTwilioSubaccountSettings();
    });
  }
}
